import React from 'react';
import { makeStyles } from '@material-ui/core';
import { GreshamLogo } from '../../assets';

const useStyles = makeStyles({
  svg: {
    width: '200px',
    height: '60px',
    objectFit: 'contain',
  },
});

export const LogoBig = () => {
  const classes = useStyles();

  return (
    <img 
      className={classes.svg}
      src={GreshamLogo}
      alt="Gresham Tech Logo"
    />
  );
};
